import React from 'react';
import { css } from 'linaria';
import { Typography } from 'common/components';
import { SEASON_START_HOUSE_CDN_PATH } from '../../house-page-constants';

export const housePageBenefits = css`
  padding: 16px;
  margin: 0;
  background-color: var(--background-secondary);
  display: flex;
  border-radius: var(--rounding-l);
  list-style: none;
  width: 100%;
  justify-content: space-between;

  li {
    display: flex;
    width: 336px;
    align-items: center;

    @media (--only-desktop) {
      width: 293px;
    }

    @media (--only-tablet) {
      width: 211px;
    }

    @media (--only-mobile) {
      width: 100%;
    }
  }

  @media (--only-mobile) {
    flex-direction: column;
    row-gap: 16px;
    column-gap: 8px;
  }
`;

const housePageBenefitIcon = css`
  width: 92px;
  height: 60px;

  @media (--to-desktop) {
    width: 72px;
    height: 46px;
  }
`;

export const HousePageBenefits = () => (
  <ul className={housePageBenefits}>
    <li>
      <img
        alt="Иконка проекта"
        className={housePageBenefitIcon}
        src={`${SEASON_START_HOUSE_CDN_PATH}/benefits/project-icon.png/project-icon.png`}
      />
      <Typography adaptive={false} variant="m" size="subtitle">
        Бесплатно спроектируем
      </Typography>
    </li>

    <li>
      <img
        alt="Иконка поиска"
        className={housePageBenefitIcon}
        src={`${SEASON_START_HOUSE_CDN_PATH}/benefits/search-icon.png/search-icon.png`}
      />
      <Typography adaptive={false} variant="m" size="subtitle">
        Подберём товары
      </Typography>
    </li>

    <li>
      <img
        alt="Иконка услуги"
        className={housePageBenefitIcon}
        src={`${SEASON_START_HOUSE_CDN_PATH}/benefits/service-icon.png/service-icon.png`}
      />
      <Typography adaptive={false} variant="m" size="subtitle">
        Установим
      </Typography>
    </li>
  </ul>
);
